import styled from 'styled-components';
export const RegistrationErrorContainer = styled.div `
  grid-column: 1 / -1;
`;
